import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { DebtorInformation } from "us.collection.debtor/components";

interface ICnt_DebtorInfo {}

const Cnt_DebtorInfo: React.FC<ICnt_DebtorInfo> = (props) => {

  return <DebtorInformation {...props} />;
};

export default withRouter(Cnt_DebtorInfo);
